module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ed-dropdown-menu",
    class: {
      'ed-dropdown-menu--checkboxes': _vm.hasCheckboxes, 'ed-dropdown-menu--light': _vm.isColorLight
    },
    attrs: {
      "id": _vm.id
    }
  }, [_c('button', {
    staticClass: "ed-dropdown-menu__trigger",
    on: {
      "click": function($event) {
        return _vm.dropdownMechanics(_vm.id)
      }
    }
  }, [_vm._v(_vm._s(_vm.name) + " "), _c('i', {
    staticClass: "ed-dropdown-menu__arrow icon-back-button-white"
  })]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e10e892"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/edoc-library/src/components/dropdownMenu/dropdownMenu.vue
// module id = 710
// module chunks = 42